<template>
  <div>
        <span
            style="font-weight: 600; font-size: 12px; margin-bottom: 5px; display: block; text-transform: uppercase"
        >{{ responseError.title }}</span>
    <div class="card-error-container">
      <div
          class="card-error"
          :class="responseError.totalError > 0 ? 'bg-card-red' : 'bg-card-green'">
                <span style="color: #425166; margin-top: 5px; font-size: 18px"
                >Tổng số lỗi</span
                >
        <span style="font-size: 25px">{{ responseError.totalError }}</span>
      </div>
      <div
          v-if="responseError.title !== 'Mục tiêu ngày'"
          class="card-error"
          :class="responseError.totalErrorTeaching > 0 ? 'bg-card-red' : 'bg-card-green'">
               <span style="color: #425166; margin-top: 5px; font-size: 15px"
               >Lỗi quên điền</span>
        <span style="font-size: 25px">{{ responseError.totalErrorForgetFill }}</span>
      </div>

      <div
          class="card-error"
          :class="responseError.totalErrorTeaching > 0 ? 'bg-card-red' : 'bg-card-green'"
      >
               <span style="color: #425166; margin-top: 5px; font-size: 15px"
               >Lỗi Không điền</span>
        <span style="font-size: 25px">{{ responseError.totalErrorNotFill }}</span>
      </div>

      <div
          class="card-error"
          :class="responseError.totalErrorTeaching > 0 ? 'bg-card-red' : 'bg-card-green'">
               <span style="color: #425166; margin-top: 5px; font-size: 15px"
               >Không đạt mục tiêu</span>
        <span style="font-size: 25px">{{ responseError.totalErrorNotAchieve }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardError',
  props: {
   responseError: {
     type: Object,
     default: () => ({
       title: '',
       data: []
     }),
     required: true,
   }
  },
  data() {
    return {};
  },
}


</script>

<style scoped>
.card-error-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

@media (max-width: 600px) {
  .card-error-container {
    flex-direction: column;
    gap: 12px;
  }

  .card-error {
    width: 100%;
    min-width: 0;
  }
}

.card-error {
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  width: 170px;
  height: 112px;
  padding: 15px;
}

.card-error:hover {
  box-shadow: 0 14px 18px rgba(0, 0, 0, 0.1);
  margin-top: -10px;
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-top 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: cardErrorHover 0.2s;
}

@keyframes cardErrorHover {
  0% {
    box-shadow: none;
    margin-top: 0;
  }
  100% {
    box-shadow: 0 14px 18px rgba(0, 0, 0, 0.1);
    margin-top: -10px;
  }
}

@media (max-width: 600px) {
  .card-error {
    width: 100% !important;
    min-width: 0;
  }
}

.bg-card-red {
  background: #FFE2E5;
}

.bg-card-green {
  background: #E2FFEC;
}
</style>
